import Competencies from "./Competencies";
import BaseApi from "../../BaseApi";

export default class TechnicalCompetencies extends Competencies {
    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1")
            + "assessment-models/technical-competencies";
    }
}
